<template>
  <div class="container">
    <vx-card title="Cuenta STP PF">
      <stp-account-pf-form
        :personal-profile-id="parseInt($route.params.id)" />
    </vx-card>
  </div>
</template>

<script>
import StpAccountPfForm from "@views/admin/StpAccount/Person/StpAccountPfForm";
export default {
  name: "Index",
  components: {StpAccountPfForm}
}
</script>

<style scoped>

</style>
